import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./SuccessToast.css";

export const SUCCESS_TOAST_DURATION_MS = 2700;

export const useSuccessToast = () => {
  const [successToast, setSuccessToast] = useState(null);
  const toastTimerRef = useRef(null);
  const toastIdRef = useRef(0);

  const showSuccessToast = useCallback((title) => {
    clearTimeout(toastTimerRef.current);
    toastIdRef.current += 1;
    setSuccessToast({
      id: toastIdRef.current,
      title,
    });
    toastTimerRef.current = setTimeout(() => {
      setSuccessToast(null);
    }, SUCCESS_TOAST_DURATION_MS);
  }, []);

  useEffect(() => () => {
    clearTimeout(toastTimerRef.current);
  }, []);

  return {
    showSuccessToast,
    successToast,
  };
};

const SuccessToast = ({ title }) => {
  if (!title) {
    return null;
  }

  const toast = (
    <div className="success-toast" role="status" aria-live="polite">
      <span className="success-toast-icon" aria-hidden="true" />
      <strong>{title}</strong>
    </div>
  );

  if (typeof document === "undefined") {
    return toast;
  }

  return createPortal(toast, document.body);
};

export default SuccessToast;
